import { api } from '@/utils/api'
import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaCm030 {
  // GET parameters
  export namespace Get {
    export interface Request {
      query: {
        reportType: number // 0: 実力テスト, 1: 月例テスト, 2: 学習診断レポート, 3: マンスリーチェックリスト, 4: T提出課題
        offset: string
        limit: number
        courseType?: string // reportTypeが0（実力テスト）の場合のみ要求され、値域は ['A', 'T']
      }
    }

    interface reportListObject {
      reportId: string
      memNum: string
      grade: number
      fiscalYear: number
      attendedMonth: number
      testCountPerMonth: number
      isRead?: boolean
      testType: number
    }

    export interface Response {
      reportType: number
      reportList: reportListObject[]
    }
  }

  // API Path
  const path: string = '/v2/ta/monthlist'

  export const parameterAssertion = (params: Get.Request): boolean => {
    const reportType = params.query.reportType
    const courseType = params.query.courseType
    // Condition1: ReportTypeが有効な値かどうか
    const cond1 = [0, 1, 2, 3, 4].includes(reportType)
    // Condition2: ReportTypeが0の場合、CourseTypeが指定されているかどうか（月例）
    const cond2 = reportType !== 0 && courseType === undefined
    // Condition3: ReportTypeが0の場合、CourseTypeが有効な値かどうか（実力テスト用）
    const cond3 = reportType === 0 && courseType !== undefined && ['A', 'T'].includes(courseType)
    // Condition4: ReportTypeが4の場合、CourseTypeが有効な値かどうか（T提出課題用）
    const cond4 = reportType === 4 && courseType !== undefined && ['T'].includes(courseType)
    return cond1 && (cond2 || cond3 || cond4)
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      if (!parameterAssertion(params)) {
        return new Promise<R | null>(resolve => {
          resolve(null)
        })
      }

      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        reportType: 0,
        reportList: [
          {
            reportId: '',
            memNum: '',
            grade: 0,
            fiscalYear: 0,
            attendedMonth: 0,
            testCountPerMonth: 0,
            testType: 1,
          },
        ],
      }
      // 実力テスト、月例テスト、および提出課題の場合はisReadを追加
      if ([0, 1, 4].includes(params.query.reportType)) {
        validationSample.reportList[0].isRead = false
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )

      // dummyserverでの確認はこちらを使用してください
      // offsetとlimitで決められた範囲を取得する振る舞いを擬似的に再現しています
      // return this.callbackWrapper<Get.Response, ResponseError, R>(
      //   api.get<Get.Response>(path, { params: params.query }),
      //   successHandler,
      //   errorHandler,
      //   validationSample,
      //   validationErrorSample
      // ).then((val: any) => {
      //   return !val
      //     ? null
      //     : ({
      //         reportType: val.reportType,
      //         reportList: val.reportList.slice(
      //           Number(params.query.offset),
      //           params.query.limit + Number(params.query.offset)
      //         ),
      //       } as any)
      // })
    }
  }
}
